module.exports = __webpack_public_path__ + "img/car_scrappage4.67d4fd73.jpeg";